import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import React, { FC, ReactElement } from 'react';
import { Error } from 'src/components/Error';
import { NoResults } from '../../../components/no-results';
import { QueryLoading } from '../../../components/query-loading';
import AllDetails from '../../../graphql/fragments/AllDetails';
import { IOrder } from '../../../graphql/types';

const ORDER_SEARCH_BY_ID = gql`
  ${AllDetails}
  query OrderByID($id: String!, $soldToId: String!) {
    order(id: $id, soldToId: $soldToId) {
      ...AllDetails
    }
  }
`;

interface IOrderByIdQueryProps {
  id: string;
  soldToId: string;
  render: (order: IOrder) => ReactElement;
}

const GetOrderByIdQuery: FC<IOrderByIdQueryProps> = ({
  id,
  soldToId,
  render,
}) => {
  const { data, loading, error } = useQuery(ORDER_SEARCH_BY_ID, {
    variables: {
      id,
      soldToId,
    },
  });

  if (loading) {
    return <QueryLoading />;
  } else if (error) {
    return <Error />;
  } else if (!data || !data.order) {
    return <NoResults />;
  }
  return render(data.order);
};

export { GetOrderByIdQuery };
